import axios from 'axios';

let prefix = "/gacha-pull"

const GachaPullApi = {
	createGachaPull(payload) {
		return axios.post(prefix + "/create", payload)
	},
	bulkCreateGacha(payload) {
		return axios.post(prefix + "/bulk-create", payload)
	},
}

export default GachaPullApi;